import { render, staticRenderFns } from "./AlertStatusIndicators.vue?vue&type=template&id=08997dc6&scoped=true&"
import script from "./AlertStatusIndicators.vue?vue&type=script&lang=js&"
export * from "./AlertStatusIndicators.vue?vue&type=script&lang=js&"
import style0 from "./AlertStatusIndicators.vue?vue&type=style&index=0&id=08997dc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08997dc6",
  null
  
)

export default component.exports